import { X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface KBChipProps {
  kbId: string;
  title: string;
  onRemove: () => void;
}

export const KBChip = ({ kbId, title, onRemove }: KBChipProps) => {
  return (
    <Badge variant="secondary" className="gap-1 pr-1">
      <span className="text-xs truncate max-w-[120px]">{title}</span>
      <button
        onClick={onRemove}
        className="hover:bg-muted rounded-full p-0.5"
        aria-label={`Disconnect ${title}`}
      >
        <X className="h-3 w-3" />
      </button>
    </Badge>
  );
};
